import { render, staticRenderFns } from "./Copyaccount.vue?vue&type=template&id=1386bd6e&"
import script from "./Copyaccount.vue?vue&type=script&lang=js&"
export * from "./Copyaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports